import {EzButton, EzLink} from '@ezcater/recipe';
import styled from '@emotion/styled';
import {useTranslation} from 'react-i18next';
import PhoneNumbers from 'constants/PhoneNumbers';

const DialogOverlay = styled('div')`
  margin: 50px auto 0 auto;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  color: #666;
  text-align: center;
  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial,
    'Lucida Grande', sans-serif;
  font-size: 20px;
`;

const Dialog = styled('div')`
  margin: 15px;
  padding: 40px;
  border: 1px solid #ccc;
  border-radius: 12px;
  -moz-border-radius: 12px;
  -webkit-border-radius: 12px;
`;

const LogoLink = styled('a')`
  display: inline-block;

  img {
    height: auto;
    width: 100%;
    max-width: 238px;
  }
`;

const Heading = styled('h1')`
  color: #369;
`;

const DialogContent = styled('div')`
  a {
    white-space: nowrap;
  }

  > * + * {
    margin-top: 16px;
  }
`;

const hardRefreshPage = (): void => {
  if (typeof window !== 'undefined') window.location.reload();
};

const ErrorDialog = () => {
  const {t} = useTranslation();

  return (
    <DialogOverlay>
      <Dialog>
        <LogoLink href="https://www.ezcater.com">
          <svg
            width="238"
            height="56"
            viewBox="0 0 130 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="ezCater logo"
          >
            <path
              d="M15.6558 7.83205C15.6057 7.83205 15.5675 7.7859 15.5745 7.73462L16.6279 0H3.92218L4.97558 7.73419C4.98256 7.78547 4.94434 7.83162 4.8942 7.83162H0L2.75699 18.5752C2.90043 19.135 3.33774 19.5487 3.86793 19.6577H16.6821C17.2123 19.5487 17.6496 19.135 17.7931 18.5752L20.55 7.83162H15.6558V7.83205ZM15.5247 8.10043L14.5334 15.4662C14.505 15.6778 14.3316 15.8346 14.1265 15.8346H6.42353C6.21844 15.8346 6.045 15.6774 6.01664 15.4662L5.02531 8.10043C5.01832 8.04915 5.05695 8.00299 5.10669 8.00299H15.4434C15.4931 8.00299 15.5317 8.04915 15.5247 8.10043Z"
              fill="#003D24"
            />
            <path
              d="M107.129 12.6803H118.668C118.733 12.0089 118.733 11.4717 118.733 10.9683C118.733 5.83196 115.811 2.60889 111.005 2.60889C106.2 2.60889 103.245 5.96615 103.245 11.2038C103.245 16.4414 106.394 19.9999 111.2 19.9999C115.016 19.9999 117.439 17.9691 118.436 14.8461H114.457C113.917 15.9529 112.81 16.6418 111.232 16.6418C108.794 16.6418 107.274 15.1995 107.051 12.7683C107.046 12.7213 107.083 12.6803 107.128 12.6803H107.129ZM107.048 9.52769C107.202 7.31401 108.628 5.80846 111.156 5.83196C114.996 5.86743 114.836 9.53196 114.836 9.53196C114.836 9.5653 114.81 9.59222 114.778 9.59222H107.106C107.072 9.59222 107.045 9.5623 107.048 9.52769Z"
              fill="#003D24"
            />
            <path
              d="M94.5778 15.253V6.58846C94.5778 6.55214 94.5494 6.52265 94.5145 6.52265H91.7538V2.95385H94.5145C94.5494 2.95385 94.5778 2.92436 94.5778 2.88803V0H98.4416V2.88803C98.4416 2.92436 98.47 2.95385 98.5049 2.95385H102.181V6.52265H98.5049C98.47 6.52265 98.4416 6.55214 98.4416 6.58846V14.3406C98.4416 15.4218 98.8312 15.8244 99.9352 15.8244H102.181V19.6735H98.6364C95.8441 19.6735 94.5778 18.6021 94.5778 15.253Z"
              fill="#003D24"
            />
            <path
              d="M120.475 2.95361H123.884V5.41686C123.884 5.4784 123.967 5.49122 123.985 5.43267C124.461 3.8519 125.654 2.95404 127.488 2.95404H130V6.5019H127.066C125.183 6.5019 124.338 7.51558 124.338 9.57669V19.6737H120.475V2.95361Z"
              fill="#003D24"
            />
            <path
              d="M67.8307 2.60791C62.9923 2.60791 59.7783 6.23355 59.7783 11.3699C59.7783 16.5062 62.7979 19.9977 67.6358 19.9977C72.0845 19.9977 74.7466 16.9425 75.1687 13.5857H71.2399C70.9152 15.2306 69.6165 16.372 67.7657 16.372C65.363 16.372 63.772 14.4583 63.772 11.3032C63.772 8.14808 65.3305 6.23441 67.7982 6.23441C69.7295 6.23441 70.8626 7.3562 71.1667 8.65107H75.1004C75.1004 7.38141 73.7951 2.60791 67.8307 2.60791Z"
              fill="#003D24"
            />
            <path
              d="M44.9877 15.8241L53.4424 6.55874C53.4621 6.53737 53.4473 6.50148 53.4189 6.50148H44.9877V2.95361H58.5926V6.50148L50.1363 15.7686C50.117 15.7895 50.1314 15.8241 50.1593 15.8241H58.5926V19.6733H44.9877V15.8241Z"
              fill="#003D24"
            />
            <path
              d="M32.1776 12.6803H43.7169C43.7818 12.0089 43.7818 11.4717 43.7818 10.9683C43.7818 5.83196 40.8596 2.60889 36.0542 2.60889C31.2488 2.60889 28.2941 5.96615 28.2941 11.2038C28.2941 16.4414 31.4436 19.9999 36.249 19.9999C40.0655 19.9999 42.488 17.9691 43.4851 14.8461H39.5058C38.9657 15.9529 37.8593 16.6418 36.281 16.6418C33.8426 16.6418 32.3235 15.1995 32.0999 12.7683C32.0954 12.7213 32.1316 12.6803 32.1772 12.6803H32.1776ZM32.0966 9.52769C32.2512 7.31401 33.6769 5.80846 36.2046 5.83196C40.0454 5.86743 39.8851 9.53196 39.8851 9.53196C39.8851 9.5653 39.8592 9.59222 39.8272 9.59222H32.1546C32.1209 9.59222 32.0942 9.5623 32.0966 9.52769Z"
              fill="#003D24"
            />
            <path
              d="M90.6454 15.8241C90.3207 15.8241 90.1583 15.6566 90.1583 15.3207V8.1468C90.1583 4.62159 87.8855 2.60791 84.0537 2.60791C79.6918 2.60791 77.4531 4.37671 77.086 7.65577H80.9268C81.1837 6.37158 82.0308 5.89808 83.7944 5.89808C85.6451 5.89808 86.4893 6.63654 86.4893 8.38227V9.11218C86.4893 9.15449 86.4577 9.18953 86.4166 9.1921L82.0731 9.4562C78.2093 9.72458 76.2932 11.8062 76.2932 14.8276C76.2932 18.0169 78.631 19.9977 82.3004 19.9977C84.5473 19.9977 86.2838 19.3263 87.223 17.9626C87.223 17.9626 87.3232 17.8036 87.3335 17.9703C87.336 18.9951 87.9899 19.6741 89.1189 19.6741H92.0411V15.825L90.6458 15.8241H90.6454ZM86.4889 13.1147C86.4889 15.4981 84.9629 16.7071 82.8199 16.7071C81.099 16.7071 80.1574 15.9015 80.1574 14.6925C80.1574 13.5848 80.9692 12.678 82.6576 12.5438L86.4269 12.2135C86.4601 12.2105 86.4889 12.2378 86.4889 12.2729V13.1147Z"
              fill="#003D24"
            />
          </svg>
        </LogoLink>
        <Heading>{t('generalError.header')}</Heading>
        <DialogContent>
          <p>{t('generalError.dialogMessage.line1')}</p>
          <p>
            {t('generalError.dialogMessage.line2')}{' '}
            <EzLink href={`tel:${PhoneNumbers.EZDISPATCH_DIRECT}`}>
              {PhoneNumbers.EZDISPATCH_DIRECT}
            </EzLink>
            .
          </p>
          <EzButton onClick={hardRefreshPage}>{t('generalError.reloadButtonLabel')}</EzButton>
        </DialogContent>
      </Dialog>
    </DialogOverlay>
  );
};

export default ErrorDialog;
